<template>
  <div class="h5-filter">
    <H5SortFilter
      class="h5-filter__item"
      v-model:sort="sort"
    />
    <H5PriceFilter
      class="h5-filter__item"
      v-model:price-start="priceStart"
      v-model:price-end="priceEnd"
      @submit="$emit('done')"
    />
  </div>
</template>

<script setup>
import H5PriceFilter from './H5PriceFilter.vue'
import H5SortFilter from './H5SortFilter.vue'

defineEmits(['done'])

const sort = defineModel('sort', { type: Object, default: null })

const priceStart = defineModel('priceStart', { type: Number, default: null })

const priceEnd = defineModel('priceEnd', { type: Number, default: null })
</script>

<style lang="less">
.h5-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  &__item {
    flex-shrink: 0;
  }
}
</style>
